import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import SideBar from "../common/sideBar";
import HeaderAdminpanel from "../common/HeaderAdminpanel";  
import { axiosInstnace as Axios } from "../../../util/util";
import { endPoints } from "../../../config";
import Pagination from "../common/Pagination";
import NoData from "../common/NoData";
import { history } from "../../../history/history";
import moment from "moment";

const roleAccessControl = (props) => {
  //Set the initial state
  const [user, handleUser] = useState([]);
  const [skip, handleSkip] = useState(0);
  const [count, handleCount] = useState(0);
  const [searchName, handleSearchName] = useState(undefined);
  const adminData = JSON.parse(localStorage.getItem("adminInfo"));
  const [industryList, handleIndustryList] = useState([]);
  const [clusterList, handleClusterList] = useState([]);
  const [searchState, handleSearchState] = useState('');
  const [searchCity, handleSearchCity] = useState('');
  const [searchIndustry, handleSearchIndustry] = useState('');
  const [searchCluster, handleSearchCluster] = useState('');

  useEffect(() => {
    /* getUser(0);
    getIndustryList();
    getClusterData(); */
    debugger;
  }, []);

  //Fetching the users
  const getUser = async (skip, name) => {
    handleSkip(skip);
    // console.log(localStorage.getItem("adminRole"));
    let param = {
      skip,
      name,
    };
    var adminInfo = JSON.parse(localStorage.getItem("adminInfo"));
    param = {
      skip,
      name,
      adminEmail: adminInfo.email,
    };
    if (localStorage.getItem("adminRole") && localStorage.getItem("adminRole") == "stationAdmin") {
      // console.log(adminInfo);
      param = {
        skip,
        name,
        state: adminInfo.state ? adminInfo.state : "",
        city: adminInfo.city ? adminInfo.city : "",
        station: adminInfo.station ? adminInfo.station : "",
        cluster: adminInfo && adminInfo.cluster ? adminInfo.cluster : "",
      };
    }else if(searchState || searchCity || searchIndustry || searchCluster){
      param = {
        skip,
        state: searchState,
        city: searchCity,
        industry: searchIndustry,
        cluster: searchCluster
      };
    }
    try {
      const data = await Axios.get(endPoints.getUser, {
        params: param,
      });
      const result = data.data.data.data;
      debugger;
      if (result && !name) {
        handleUser(result);
        handleCount(data.data.data.count);
      } else {
        handleUser(result);
        handleSearchName(name);
      }
    } catch (error) {
      console.log(error);
      // handleRodp([])
    }
  };

  const goToRoute = (name, data, path) => {
    history.push(path, { [name]: data });
  };

  //Searching the user
  const getSearch = (e) => {
    // getUser(0, e.target.value);
  };
  
  const clearSearch = (e) => {
    handleSearchState('');
    handleSearchCity('');
    handleSearchIndustry('');
    handleSearchCluster('');
    getUser(0, '');
  };

  const filterSearch = (e) => {
    getUser(0, '');
  };
  
  const getIndustryList = async () => {
    const response = await Axios.get(`${endPoints.getIndustryList}`);
    let industryList = response.data.data.data;
    handleIndustryList(industryList);
  };

  const getClusterData = async () => {
    try {
      const response = await Axios.get(`${endPoints.getClusters}`, {
        params: {
          type: "all",
          withoutTradepartnerList: true
        },
      });
      let result = response.data.data.allData;
      result = result
        .map((e) => {
          return e.name;
        })
        .sort();
      if (result) {
        handleClusterList(result);
      }
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="dashboardContainer">
       <HeaderAdminpanel/>

      {/* <div className="navbar-header dashboard-header clearfix">
        <div className="logo-dashboard">
          <a id="logo">
            <img className="logo-trans" src="/assets/images/new_logo.png" />
          </a>
          <span>Welcome: {adminData.email} </span>
          <span>Last Login @ {moment(adminData.lastLogin).format("DD/MM/YYYY hh:mm A")}</span>
        </div>
        <div
          className="user-profile pull-right"
          tabIndex={0}
          onClick={() => {
            localStorage.removeItem("adminInfo");
            window.location.href = "/admin/login";
          }}
        >
          <a>
            <span>
              LOGOUT
              <span className="log_img">
                <img src="/assets/images/ic_logout.png" />
              </span>
            </span>
          </a>
        </div>
      </div> */}
      <div className="dashboardContainer-inner">
        <section id="sidebar">
          <SideBar role={localStorage.getItem("adminRole")} />
        </section>
        <section id="dashboard-rightContainer" className="dashboard-manageSales">
          <div className="container-head">
            <div className="dashboard-breadcrumb">
              Roles Management |<span className="breadcrumb-active fct-breadcrumb">Role Access</span>
            </div>
          </div>
          <div className="dashboard-content userListing-dashboard bg-white table-responsive">
            <table className="table table-striped master-table">
              <thead>
                <tr>
                  <th>Actions\Roles</th>
                  <th>Super Admin</th>
                  <th>Audio Admin</th>
                  <th>Audit Admin</th>
                  <th>Campaign Admin</th>
                  <th>Cluster Admin</th>
                  <th>Trade Partner</th>
                  <th>Finance Admin</th>
                  <th>Package Admin</th>
                  <th>Sales User</th>
                  <th>Station Admin</th>
                  <th>Traffic Admin</th>
                  <th>User</th>
                </tr>
              </thead>
              <tbody>
                <tr key={0}>
                  <td>System Configuration</td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                        checked
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  
                </tr>
                <tr key={1}>
                  <td>User Management</td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                        checked
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                        checked
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                        checked
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  
                </tr>
                <tr key={2}>
                  <td>Audio Management</td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                        checked
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                        checked
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                        checked
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  
                </tr>
                <tr key={3}>
                  <td>Campaign Management</td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                        checked
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                        checked
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  
                </tr>
                <tr key={4}>
                  <td>Payment Management</td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                        checked
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  
                </tr>
                <tr key={5}>
                  <td>Package Management</td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                        checked
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  
                </tr>
                <tr key={6}>
                  <td>Rate Management</td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                        checked
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  
                </tr>
                <tr key={7}>
                  <td>Contact Us</td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                        checked
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                        checked
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                        checked
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  
                </tr>
                <tr key={8}>
                  <td>Manage Coupons</td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                        checked
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  
                </tr>
                <tr key={9}>
                  <td>Trade Partner</td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                        checked
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                        checked
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  
                </tr>
                <tr key={10}>
                  <td>Incentive Management</td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                        checked
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                        checked
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  
                </tr>
                <tr key={11}>
                  <td>Coupons</td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                        checked
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  
                </tr>
                <tr key={12}>
                  <td>Notification</td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                        checked
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  
                </tr>
                <tr key={13}>
                  <td>Role Management</td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                        checked
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  <td>
                    <p>
                      <input
                        className="margn-rgt-10"
                        name="checkbox1"
                        type="checkbox"
                      />
                    </p>
                  </td>
                  
                </tr>
              </tbody>
            </table>
            <div className="paginationTable">
              
            </div>
          </div>
          
        </section>
      </div>
    </div>
  );
};

export default connect(null, {})(roleAccessControl);



// WEBPACK FOOTER //
// ./web/components/admin/rolemanagement/roleAccessControl.js